module.exports = __webpack_public_path__ + "img/facebook.75e5ad1c.svg";